// @ts-ignore
import { storage } from '@gp/utils/utils';
import { goToProjectDetailsPage } from '@gp/utils/project';
import { PROJECT_DETAIL_STORAGE_KEY } from '@gp/constants/storageKeys';
import { GAME_DETAIL_MODULE_KEY_MAPPING } from '@gp/pages/Pipeline/ProjectDetails/GameDetail/constants';
import { FINANCE_MODULE_KEY_MAPPING } from '@gp/pages/Pipeline/ProjectDetails/Finance/constants';
import { STAKEHOLDER_MODULE_KEY_MAPPING } from '@gp/pages/Pipeline/ProjectDetails/Stakeholder/consts';
import { TAB_NAME_KEY_MAPPING } from '../../../../../constants';

import type { IRecord } from '@gp/types/global';

interface IProjectDetailNavigatorCommonParams {
  tab?: string;
  titleId?: string;
  title?: string;
  projectId?: string;
  projectName?: string;
}

const PROJECT_DETAIL_GAME_DETAIL_MODULE_KEY_MAPPING: IRecord<string> = {
  'Game Information': GAME_DETAIL_MODULE_KEY_MAPPING.GAME_INFORMATION,
  'Visual Showcase': GAME_DETAIL_MODULE_KEY_MAPPING.VISUAL_SHOWCASE,
  'Similar Games': GAME_DETAIL_MODULE_KEY_MAPPING.SIMILAR_GAMES,
};

const PROJECT_DETAIL_FINANCE_MODULE_KEY_MAPPING: IRecord<string> = {
  'Key Metrics': FINANCE_MODULE_KEY_MAPPING.KEY_METRICS,
  Trends: FINANCE_MODULE_KEY_MAPPING.TRENDS,
};

const PROJECT_DETAIL_STAKEHOLDER_MODULE_KEY_MAPPING: IRecord<string> = {
  IEGG: STAKEHOLDER_MODULE_KEY_MAPPING.IEGG,
  Studio: STAKEHOLDER_MODULE_KEY_MAPPING.STUDIO,
};

const navigate2ProjectDetailCommon = (
  moduleKeyMapping: IRecord<string>,
  defaultModuleKey: string,
  params?: IProjectDetailNavigatorCommonParams,
) => {
  const { tab, title, projectId, projectName } = params || {};
  const moduleKey = moduleKeyMapping?.[title || ''] || defaultModuleKey || '';
  storage.setSessionStorageItem(PROJECT_DETAIL_STORAGE_KEY.GPOP_CACHE_PROJECT_DETAIL_TAB_STORAGE_KEY, tab);
  storage.setSessionStorageItem(PROJECT_DETAIL_STORAGE_KEY.GPOP_CACHE_PROJECT_DETAIL_TAB_MODULE_STORAGE_KEY, moduleKey);
  // @ts-ignore
  goToProjectDetailsPage({ id: projectId || '', name: projectName || '', tab });
};

const navigate2ProjectDetailGameDetail = (params?: IProjectDetailNavigatorCommonParams) => {
  const paramsTmp = { ...params, tab: 'gameDetail' };
  navigate2ProjectDetailCommon(PROJECT_DETAIL_GAME_DETAIL_MODULE_KEY_MAPPING, 'game_information', paramsTmp);
};

const navigate2ProjectDetailMilestone = (params?: IProjectDetailNavigatorCommonParams) => {
  const { projectId, projectName, titleId } = params || {};
  storage.setSessionStorageItem(PROJECT_DETAIL_STORAGE_KEY.GPOP_CACHE_MILESTONE_ID_STORAGE_KEY, titleId);
  // @ts-ignore
  goToProjectDetailsPage({ id: projectId || '', name: projectName || '', tab: 'milestone' });
};

const navigate2ProjectDetailUpdate = (params?: IProjectDetailNavigatorCommonParams) => {
  const { projectId, projectName, titleId } = params || {};
  storage.setSessionStorageItem(PROJECT_DETAIL_STORAGE_KEY.GPOP_CACHE_UPDATE_ID_STORAGE_KEY, titleId);
  // @ts-ignore
  goToProjectDetailsPage({ id: projectId || '', name: projectName || '', tab: 'projectUpdate' });
};

const navigate2ProjectDetailFinance = (params?: IProjectDetailNavigatorCommonParams) => {
  const paramsTmp = { ...params, tab: 'finance' };
  navigate2ProjectDetailCommon(PROJECT_DETAIL_FINANCE_MODULE_KEY_MAPPING, 'key_metrics', paramsTmp);
};

const navigate2ProjectDetailTechnical = (params?: IProjectDetailNavigatorCommonParams) => {
  const { projectId, projectName } = params || {};
  // @ts-ignore
  goToProjectDetailsPage({ id: projectId || '', name: projectName || '', tab: 'technical' });
};

const navigate2ProjectDetailStakeholder = (params?: IProjectDetailNavigatorCommonParams) => {
  const paramsTmp = { ...params, tab: 'stakeholder' };
  navigate2ProjectDetailCommon(PROJECT_DETAIL_STAKEHOLDER_MODULE_KEY_MAPPING, 'iegg', paramsTmp);
};

const PROJECT_DETAIL_TAB_PAGE_NAVIGATOR_MAPPING = {
  [TAB_NAME_KEY_MAPPING.DETAIL]: navigate2ProjectDetailGameDetail,
  [TAB_NAME_KEY_MAPPING.MILESTONE]: navigate2ProjectDetailMilestone,
  [TAB_NAME_KEY_MAPPING.UPDATE]: navigate2ProjectDetailUpdate,
  [TAB_NAME_KEY_MAPPING.FINANCE]: navigate2ProjectDetailFinance,
  [TAB_NAME_KEY_MAPPING.STAKEHOLDER]: navigate2ProjectDetailStakeholder,
  [TAB_NAME_KEY_MAPPING.TECHNICAL]: navigate2ProjectDetailTechnical,
};

export const navigate2ProjectDetail = (params?: IProjectDetailNavigatorCommonParams) => {
  const { tab, ...restParams } = params || {};
  const navigator =
    PROJECT_DETAIL_TAB_PAGE_NAVIGATOR_MAPPING[tab as string] ||
    PROJECT_DETAIL_TAB_PAGE_NAVIGATOR_MAPPING[TAB_NAME_KEY_MAPPING.DETAIL];
  navigator(restParams);
};
